import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface PersonaSelectProps {
  personas: { id: string; name: string }[];
  currentPersona: { id: string; name: string } | null;
  onLoad: (id: string) => void;
}

const PersonaSelect = (props: PersonaSelectProps) => {
  const { personas, currentPersona, onLoad } = props;
  return (
    <div className="flex-1 min-w-[160px] max-w-[280px]">
      <Select value={currentPersona?.id ?? ""} onValueChange={onLoad}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Load a saved persona…" />
        </SelectTrigger>
        <SelectContent>
          {personas.length === 0 ? (
            <div className="px-3 py-2 text-sm text-muted-foreground">
              No saved personas
            </div>
          ) : (
            personas.map((p) => (
              <SelectItem key={p.id} value={p.id}>
                {p.name}
              </SelectItem>
            ))
          )}
        </SelectContent>
      </Select>
    </div>
  );
};

export default PersonaSelect;
